import { Step } from '@storebrand-digital/insurance-stepper';

export const markCompletedSteps = (stepperIndex: number, steps: Step[]) => {
  // show previous steps as completed when refreshing the page
  if (stepperIndex !== 0) {
    for (let i = stepperIndex; i > 0; i--) {
      steps[i - 1].complete = true;
    }
  }

  // set current Step to false to show the step as active
  steps[stepperIndex].complete = false;
};

/**
 *
 * The schema contains of two forms: Intro + Claim. When rendering,
 * each form starts with index = 0. Therefore, the default index
 * value created cannot be used to set current Step in the Stepper
 * (When the claim form starts with index = 0, Stepper will show
 * Step 1 as active step instead of Step 4).
 *
 * This function returns the correct Stepper index based on the
 * current page in the schema.
 *
 */
export const getStepperIndex = (
  pageNumber: number,
  pathname: string,
  pageCount: number,
  isCorporate: boolean,
  formData: {
    [key: string]: unknown;
  }
) => {
  const privateContactInfoPageIndex = 2;
  const claimForm = 3;
  const registrationPage = 4;

  const lastPage = pageCount - 1;
  const hasVehicleIdentificationPage = formData.__needFleetVehicleId__ === true;

  // show the vehicleIdentification page as Step 1 and display the correct step number for the rest of the intro form based on the form index
  if (
    hasVehicleIdentificationPage &&
    (pathname.includes('bedrift/kjoretoy/intro/') ||
      pathname.includes('bedrift/campingvogn-og-tilhenger/intro/'))
  ) {
    return pageNumber > 0 ? pageNumber - 1 : pageNumber;
  }

  // ensure the Stepper does not initiate at Step 1 after the intro form, as the claim form begins with an index of 0
  if (!pathname.includes('intro')) {
    // private forms only contain two intro pages, while corporate forms have three
    // the first page of the private claim forms is the contact information page and must be set to Step 3
    if (pageNumber === 0 && !isCorporate) {
      return privateContactInfoPageIndex;
    }

    return pageNumber !== lastPage ? claimForm : registrationPage;
  }

  return pageNumber;
};
